import { render, staticRenderFns } from "./PasswdChange.vue?vue&type=template&id=389acc06&scoped=true"
import script from "./PasswdChange.vue?vue&type=script&lang=js"
export * from "./PasswdChange.vue?vue&type=script&lang=js"
import style0 from "./PasswdChange.vue?vue&type=style&index=0&id=389acc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389acc06",
  null
  
)

export default component.exports